module.exports = __webpack_public_path__ + "static/img/manAsa.398aa14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/manAsa.png
// module id = LIn7
// module chunks = 2